import { Component, OnInit, Inject, AfterViewInit, ElementRef, Input, Output, EventEmitter, Renderer2 } from '@angular/core';
import { Observable, Observer, timer, forkJoin } from 'rxjs';
import { environment } from '../../../environments/environment';
import { DOCUMENT } from '@angular/common';

import { LookupTypeService } from '../../services/lookup-type.service';
import * as moment from 'moment';

@Component({
	selector: 'cyber-source-form',
	templateUrl: './cyber-source-form.component.html',
	styles: []
})

export class CyberSourceFormComponent implements OnInit {

	@Input('profile') profile: any;
	@Input('orderRefNumber') orderRefNumber: string;
	@Input('selectedOrderKey') selectedOrderKey: string;
	@Input('orderAmount') orderAmount: number;
	@Input('clientKey') clientKey: string;
	@Input('email') email: string;
	@Output() closer = new EventEmitter();

	public responseEvent: string | null = null;
	public showBilling: boolean | null = null;
	public years: number[] = [];
	public regionsList: any[] = [];
	public countriesList: any[] = [];
	public cardholderName: string = null;
	public emailAddress: string = null;
	public address1: string = null;
	public locality: string = null;
	public region: string = null;
	public postalCode: string = null;
	public country: string = null;
	public phoneNumber: string = null;
	public expiryMonth: string = null;
	public expiryYear: number = null;
	public errorsModel: any = null;
	public loading: boolean = true;

	public cardholderNameError: string;
	public cardNumberError: string;
	public securityCodeError: string;
	public expiryMonthError: string;
	public expiryYearError: string;
	public emailAddressError: string;
	public address1Error: string;
	public localityError: string;
	public regionError: string;
	public postalCodeError: string;
	public countryError: string;
	public phoneNumberError: string;
	constructor(@Inject(DOCUMENT) private document, private renderer: Renderer2, private elementRef: ElementRef, private _lookupService: LookupTypeService) {
		this.getCacheableLists();
	}
	
	ngOnInit(): void {
		this.loading = true;
		var yr: number = moment().year();
		for (var i = 0; i < 11; i++) {
			this.years.push(yr + i);
		}

		this.showBilling = (this.profile?.params?.find((f:any) => { return f.name == 'showBilling'; }))?.value;
	}

	ngAfterViewInit() {
		Promise.resolve(null).then(() => {
			this.errorsModel = { message: 'Checkout form is loading...'};
			this.emailAddress = this.email;
		});
		const api = this.document.createElement('script');
		api.type = 'text/javascript';
		api.src = this.profile.processorUrl;
		this.elementRef.nativeElement.querySelector('#elemScript').appendChild(api);
		const s = this.document.createElement('script');
		s.type = 'text/javascript';
		s.text = 
		'var flex = null;' +
		'var microform = null;' +
		'var setupBoA = async() => {' +
		'if(Flex === undefined || Flex == null) {' +
		'console.log("Waiting 5 additional seconds for Flex to load.");' +
		'await delay(5000);' +
		'}' +
		'flex = new Flex("' + this.profile.captureContext + '");' +
		'microform = flex.microform();' +
		'var number = microform.createField("number", { placeholder: "Enter card number" });' +
		'var securityCode = microform.createField("securityCode", { placeholder: "•••" });' +
		'number.load("#number-container");' +
		'securityCode.load("#securityCode-container");' +
		'};' +
		'function checkBoA() {' +
		'if(microform === undefined || microform == null) {' +
		'let errorResponse = document.getElementById("errorResponse"); errorResponse.value = "Checkout form not loaded... Retrying";' +
		'errorResponse.click();' +
		'setTimeout(setupBoA, 100);' +
		'}' +
		'}' +
		'setTimeout(setupBoA, 100);' +
		'' +
		''
		;
		this.elementRef.nativeElement.querySelector('#elemSetup').appendChild(s);
		timer(5000).subscribe(() => { this.loading = false; this.errorsModel = null; });
	}

	public submitPayment() {
		this.elementRef.nativeElement.querySelector('#elemSubmit').childNodes.forEach(node => {
			this.renderer.removeChild(this.elementRef.nativeElement, node)
		});

		if(this.validateForm()) {
			const s = this.document.createElement('script');
			s.type = 'text/javascript';
			s.text = 
			'' +
			'function submitBoA() {' +
			'checkBoA();' +
			'microform.createToken({cardholderName: "' + this.cardholderName + '", expirationMonth: "' + this.expiryMonth + '", expirationYear: "' + this.expiryYear + '"}, function (err, token) {' +
			'if (err) {' +
			'let errorResponse = document.getElementById("errorResponse"); errorResponse.value = (JSON.stringify(err));' +
			'errorResponse.click();' +
			'' +
			' } else {' +
			'let tokenResponse = document.getElementById("tokenResponse"); tokenResponse.value = (token);' +
			'tokenResponse.click();' +
			'' +
			'}' +
			'});' +
			'}' +
			'' +
			'' +
			'setTimeout(submitBoA, 100);'
			;
			this.elementRef.nativeElement.querySelector('#elemSubmit').appendChild(s);
		}
	}

	public handleBoAResponseEvent(resp: string, isError: boolean) {
		this.cardholderNameError = null;
		this.cardNumberError = null;
		this.securityCodeError = null;
		this.expiryMonthError = null;
		this.expiryYearError = null;
		this.errorsModel = null;
		for(var errL of ['number', 'securityCode', 'expirationMonth', 'expirationYear']) {
			let label = document.getElementById(errL + '-label');
			if(label) {
				label.style['color'] = 'inherit';
			}
		}
		if(isError) {
			this.errorsModel = JSON.parse(resp);
			for(var errT of this.errorsModel?.details) {
				let label = document.getElementById(errT.location + '-label');
				if(label) {
					label.style['color'] = 'RED';
				}

				switch(errT.location) {
				case 'cardholderName': { this.cardholderNameError = errT.message; break; }
				case 'number': { this.cardNumberError = errT.message; break; }
				case 'securityCode': { this.securityCodeError = errT.message; break; }
				case 'expirationMonth': { this.expiryMonthError = errT.message; break; }
				case 'expirationYear': { this.expiryYearError = errT.message; break; }
				}
			}
		} else {
			this.closer.emit({ transientToken: resp, captureContext: this.profile.captureContext, clientKey: this.clientKey, processorId: this.profile.processorId, processorName: this.profile.processorName?.toLowerCase(), orderKey: this.selectedOrderKey, orderNumber: this.orderRefNumber, orderAmount: this.orderAmount, cardholderName: this.cardholderName, emailAddress: this.emailAddress, address1: this.address1, locality: this.locality, region: this.region, postalCode: this.postalCode, country: this.country, phoneNumber: this.phoneNumber });
		}
	}

	private validateForm() {
		var isValid = true;
		this.errorsModel = null;
		if(this.showBilling) {
			for(var errL of ['phoneNumber', 'country', 'postalCode', 'region', 'locality', 'address1', 'emailAddress', 'cardholderName']) {
				let label = document.getElementById(errL + '-label');
				if(label) {
					switch(errL) {
					case 'cardholderName': { if (!this.cardholderName || this.cardholderName?.trim() == ''){ isValid = false; this.errorsModel = { informationLink: '', message: 'Please provide the card holder name.' }; this.cardholderNameError = 'Please provide the card holder name.'; label.style['color'] = 'RED'; } else { label.style['color'] = 'inherit'; } break; }
					case 'emailAddress': { if (!this.emailAddress || this.emailAddress?.trim() == ''){ isValid = false; this.errorsModel = { informationLink: '', message: 'Please provide the email address.' }; this.emailAddressError = 'Please provide the address.'; label.style['color'] = 'RED'; } else { label.style['color'] = 'inherit'; } break; }
					case 'address1': { if (!this.address1 || this.address1?.trim() == ''){ isValid = false; this.errorsModel = { informationLink: '', message: 'Please provide the address.' }; this.address1Error = 'Please provide the address.'; label.style['color'] = 'RED'; } else { label.style['color'] = 'inherit'; } break; }
					case 'locality': { if (!this.locality || this.locality?.trim() == ''){ isValid = false; this.errorsModel = { informationLink: '', message: 'Please provide the locality.' }; this.localityError = 'Please provide the locality.'; label.style['color'] = 'RED'; } else { label.style['color'] = 'inherit'; } break; }
					case 'region': { if (!this.region || this.region?.trim() == ''){ isValid = false; this.errorsModel = { informationLink: '', message: 'Please provide the region.' }; this.regionError = 'Please provide the region.'; label.style['color'] = 'RED'; } else { label.style['color'] = 'inherit'; } break; }
					case 'postalCode': { if (!this.postalCode || this.postalCode?.trim() == ''){ isValid = false; this.errorsModel = { informationLink: '', message: 'Please provide the postal code.' }; this.postalCodeError = 'Please provide the postal code.'; label.style['color'] = 'RED'; } else { label.style['color'] = 'inherit'; } break; }
					case 'country': { if (!this.country || this.country?.trim() == ''){ isValid = false; this.errorsModel = { informationLink: '', message: 'Please provide the country.' }; this.countryError = 'Please provide the country.'; label.style['color'] = 'RED'; } else { label.style['color'] = 'inherit'; } break; }
					case 'phoneNumber': { if (!this.phoneNumber || this.phoneNumber?.trim() == ''){ isValid = false; this.errorsModel = { informationLink: '', message: 'Please provide the phone number.' }; this.phoneNumberError = 'Please provide the phone number.'; label.style['color'] = 'RED'; } else { label.style['color'] = 'inherit'; } break; }
					}
				}
			}
		}

		return isValid;
	}

	private getCacheableLists() {
		forkJoin(
			this._lookupService.getCacheableEnumeratedList('Region'),
			this._lookupService.getCacheableEnumeratedList('Country'))
		.subscribe(([regions, countries] :[any, any]) =>{
			this.regionsList = regions;
			this.countriesList = countries;
		}, (error: any) => {
			this.regionsList = ['Could Not Load'];
			this.countriesList = ['Could Not Load'];
		});
	}

} 